import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.9 12.199c-.958-1.275-2.213-2.332-3.63-3.055C12.784 8.385 11.179 8 9.5 8 6.666 8 3.97 9.141 2 11.152V8.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0 .276.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H2.572C4.366 10.088 6.867 9 9.5 9c3.016 0 5.786 1.385 7.6 3.799.098.131.248.2.4.2a.4995.4995 0 0 0 .399-.8z',
  ],
  height: 20,
  width: 20,
});
